import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { Formik, FormikHelpers } from "formik";
import React from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../state-management/root-reducer";
import { setSearchTerm } from "../../../../state-management/slices/global/global.slice";
import BUTTON from "../../../button/Button.component";
import ButtonStyles from "../../../button/Button.styles";
import FormConstants from "../../Form.constants";
import { FormService } from "../../Form.service";
import FormStyles from "../../Form.styles";
import {
  DefaultOutageSearchFormProps,
  IOutageSearchFormProps,
  ISearchFormValues,
} from "../../Form.types";
import FormUtils from "../../Form.utils";

const OUTAGE_SEARCH_FORM: React.FC<IOutageSearchFormProps> = (
  props: IOutageSearchFormProps
) => {
  // props
  const { onClose } = props;

  // hooks
  const dispatch = useDispatch();
  const sendDataToGTM = useGTMDispatch();

  // App state
  const { isLoading, searchedOutages } = useSelector(
    (state: RootState) => state.outages
  );
  const { searchMode } = useSelector(
    (state: RootState) => state.globalState.ui
  );
  const { searchText, activeView } = searchMode;

  // services
  const formService: FormService = FormService.getInstance(
    dispatch,
    sendDataToGTM
  );

  return (
    <FormStyles.FormContainer
      className="form-container"
      data-testid="outage-search-form"
    >
      <Formik
        validationSchema={FormUtils.searchSchema}
        initialValues={FormConstants.InitialSearchValues}
        onSubmit={(
          values: ISearchFormValues,
          actions: FormikHelpers<ISearchFormValues>
        ) => {
          dispatch(setSearchTerm(values.searchFormText));
          formService.searchOutages(values, actions);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          resetForm,
        }) => (
          <Form id="SearchForm" noValidate onSubmit={handleSubmit}>
            <FormStyles.FormGroup controlId="searchFormTextCtrl">
              <FormStyles.FormLabel className="form-label">
                Enter the email, phone number, or notification number associated
                with your reports.
              </FormStyles.FormLabel>
              <FormStyles.FormControl
                required
                type="text"
                name="searchFormText"
                className={
                  touched.searchFormText && errors.searchFormText
                    ? "search-input is-invalid"
                    : "search-input"
                }
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.searchFormText && !errors.searchFormText}
                value={values.searchFormText}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.searchFormText}
              </Form.Control.Feedback>
            </FormStyles.FormGroup>
            <FormStyles.FormSubmitContainer className="form-submit-container">
              <BUTTON
                className="search-outage-button"
                variant="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? "One Moment Please..." : "Search"}
              </BUTTON>

              <ButtonStyles.ButtonContainer className="button-container">
                <ButtonStyles.LinkButton
                  className="link-button"
                  title="Back to Outage Map"
                  type="button"
                  disabled={isLoading}
                  onClick={(event) => {
                    sendDataToGTM({
                      event: "eventTracking",
                      category: "Outage",
                      action: "Street Light",
                      label: "Back to map clicked from outage search form",
                    });

                    onClose(event);
                  }}
                >
                  Back to Outage Map
                </ButtonStyles.LinkButton>
              </ButtonStyles.ButtonContainer>
            </FormStyles.FormSubmitContainer>
          </Form>
        )}
      </Formik>
    </FormStyles.FormContainer>
  );
};

OUTAGE_SEARCH_FORM.defaultProps = DefaultOutageSearchFormProps;
export default OUTAGE_SEARCH_FORM;
